// extracted by mini-css-extract-plugin
export default {"nav":"style_nav__xqZKF","selected":"style_selected__mRjNs","open":"style_open__J8Uat","main":"style_main__Bl-zZ","elem":"style_elem__2RdKe"};